export const SECCIONES_COMANDA = ["Cocina", "Cafeteria", "Caja"];

const NORMALIZACION = {
  cocina: "Cocina",
  cafeteria: "Cafeteria",
  caja: "Caja",
};

const normalizarToken = (token) => {
  if (!token && token !== 0) return null;
  const value = String(token).trim();
  if (!value) return null;

  const normalizedKey = value
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

  return NORMALIZACION[normalizedKey] || value;
};

export const parseSeccionesComanda = (value) => {
  const raw = Array.isArray(value) ? value : String(value || "").split(",");
  const normalized = raw.flatMap((token) => {
    const parsed = normalizarToken(token);
    return parsed ? [parsed] : [];
  });
  return [...new Set(normalized)];
};

export const serializeSeccionesComanda = (value) => parseSeccionesComanda(value).join(",");

const getPrintNamesFromComanderasHabilitadas = (detalle) => {
  const comanderas = detalle?.producto?.comanderas;
  if (!Array.isArray(comanderas) || comanderas.length === 0) return [];

  const names = comanderas
    .filter((comandera) => {
      const estadoConexion = String(comandera?.estadoConexion || "").trim().toLowerCase();
      return comandera?.habilitado === true // && estadoConexion === "available";
    })
    .map((comandera) => normalizarToken(comandera?.printName))
    .filter(Boolean);

  return [...new Set(names)];
};

export const getSeccionesFromDetalle = (detalle) => {
  return getPrintNamesFromComanderasHabilitadas(detalle);
};

export const detallePerteneceASeccion = (detalle, seccion) => {
  const normalizedSeccion = normalizarToken(seccion);
  if (!normalizedSeccion) return false;
  return getSeccionesFromDetalle(detalle).includes(normalizedSeccion);
};

const normalizarEstadoDetalle = (detalle) =>
  String(detalle?.estado || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase()
    .trim();

export const detalleEsImprimible = (detalle) =>
  Boolean(detalle) &&
  !["CANCELADO", "ANULADO"].includes(normalizarEstadoDetalle(detalle));

export const detalleRequiereImpresionComanda = (detalle) =>
  detalleEsImprimible(detalle) && !detalle?.impresionComanda;

export const obtenerSeccionesInvolucradas = (detalles = []) =>
  [...new Set(detalles.flatMap((detalle) => getSeccionesFromDetalle(detalle)))];

const getCantidadDetalle = (detalle) => {
  const cantidad = Number(detalle?.cantidad);
  return Number.isFinite(cantidad) && cantidad > 0 ? cantidad : 1;
};

export const resumirImpresionesFallidasPorComandera = (impresionesFallidas = []) => {
  const resumenMap = new Map();

  impresionesFallidas.forEach((impresion) => {
    const printName = normalizarToken(impresion?.seccion) || String(impresion?.seccion || "").trim();
    if (!printName) return;

    const detalles = Array.isArray(impresion?.detalles) ? impresion.detalles : [];
    const cantidadFallida = detalles.reduce((total, detalle) => total + getCantidadDetalle(detalle), 0);
    const cantidad = cantidadFallida > 0 ? cantidadFallida : 1;

    resumenMap.set(printName, (resumenMap.get(printName) || 0) + cantidad);
  });

  return Array.from(resumenMap.entries()).map(([printName, cantidad]) => ({
    printName,
    cantidad,
  }));
};

export const formatearResumenImpresionesFallidas = (resumen = []) =>
  resumen
    .filter((item) => item?.printName)
    .map((item) => `${item.cantidad} productos en ${item.printName}`)
    .join(", ");
